import React from 'react';
import styled from 'styled-components';

import InstagramConfigurationsSettingsForm from 'src/presentation/components/pages/social/InstagramConfigurationsSettingsForm';
import EmbedModalWithGreenHeader from 'src/presentation/components/pages/shared/EmbedModalWithGreenHeader';
import { isLoadingStatus } from 'src/presentation/hooks/useResource';
import { ModalSize } from 'src/presentation/components/pages/shared/EmbedModal';
import { Spinner } from 'src/presentation/components/pages/shared/Spinner';

const InstagramConfigurationsSettingsModal = ({
  errors,
  iframeRef,
  isInstagramDirectAccountUpdateRequired,
  loadingState,
  onClose,
  targetOrigin,
  value,
}) => {
  return (
    <StyledModal
      data-aid="proactive-chat-settings-modal"
      title="Settings"
      content={
        <>
          {isLoadingStatus(loadingState) ? (
            <SpinnerWrapper>
              <Spinner />
            </SpinnerWrapper>
          ) : (
            <InstagramConfigurationsSettingsForm
              errors={errors}
              iframeRef={iframeRef}
              isInstagramDirectAccountUpdateRequired={isInstagramDirectAccountUpdateRequired}
              item={value}
              onClose={onClose}
              targetOrigin={targetOrigin}
            />
          )}
        </>
      }
      onCancel={onClose}
      modalSize={ModalSize.EXTRALARGE}
    />
  );
};

const SpinnerWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
`;

const StyledModal = styled(EmbedModalWithGreenHeader)`
  padding: 0;
`;

export default InstagramConfigurationsSettingsModal;
